import {
  cardApi,
  type CreditCardListResponse,
  type ListPaymentMethodsRequest,
  ResponseEnum,
} from "@b2bportal/card-api";
import { type IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { axiosInstance } from "../AxiosInterceptor";
import { trackEvent } from "../tracking/trackEvent";

export const listPaymentMethods = (
  req: ListPaymentMethodsRequest,
  apiConfig?: IApiConfig
): Promise<CreditCardListResponse> =>
  new Promise((resolve, reject) => {
    cardApi(axiosInstance)
      .apiV0PaymentMethodsListPost(req)
      .then((res) => {
        const responseBody = res.data;

        if (responseBody.Response === ResponseEnum.Failure) {
          reject(responseBody.errors);
        } else {
          resolve(responseBody);
        }
      })
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          apiConfig
        );
        reject(e);
      });
  });
